import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'

import TitleIcon from '@material-ui/icons/Dashboard'

const styles = {
    titleContainer : {
        padding: '20px 0',
    },
    title : {
        display: 'inline-flex',
        verticalAlign: 'middle',
        alignItems: 'center',
        fontSize: 23,
        '& svg' : { color: '#019EAC', paddingRight : 10 }
    },
}

const Title  = (props) => {
    const {classes, title, icon} = props;
    return (
        <div className={classes.titleContainer}>
            <Typography className={classes.title}>
                {icon ? icon : <TitleIcon />} {title}
            </Typography>
        </div>
    )

}

export default withStyles(styles)(Title)